import React from 'react';

function PageTitle({ content }) {
  return (
    <>
      <section className="bg-no-repeat bg-cover bg-[#04347c] h-[300px]">
        <div className="max-w-screen-xl px-4 py-8 mx-auto text-center lg:pt-24 lg:px-12">
          <h1 className="mt-20 mb-4 text-5xl font-extrabold leading-none tracking-tight text-white md:mt-2 lg:text-6xl">
            {content}
          </h1>
        </div>
      </section>
    </>
  );
}

export default PageTitle;
